// extracted by css-extract-rspack-plugin
export default {"footer":"WidgetFooter-module__footer___dBL6R"};